import React from "react";
import {ReactSession} from "react-client-session";
import queryString from "query-string";
import {toast} from "react-toastify";
import {decode as base64_decode, encode as base64_encode} from "base-64";

import { Connection } from "../../config/Connection";
import { Helpers } from "../../config/Helpers";
import GoogleMap from '../../components/GoogleMap';
import AutoComplete from "../../components/AutoComplete";

const Marker = props => {
    return <>
        <div className="pin"></div>
        <div className="pulse"></div>
    </>
}

class New extends React.Component {

    constructor(props) {
        super(props);
        ReactSession.setStoreType("localStorage");
        this.state = {
            sessUserCode: (ReactSession.get("sess_usercode")) ? ReactSession.get("sess_usercode") : '',
            sessEmail: (ReactSession.get("sess_email")) ? ReactSession.get("sess_email") : '',
            sessUserType: (ReactSession.get("sess_usertype")) ? ReactSession.get("sess_usertype") : '',
            urlParam: queryString.parse(window.location.search),

            branchCode: (ReactSession.get("branch_code")) ? ReactSession.get("branch_code") : 'CBNG-18-020001',
            mapCenter: {
                lat: -6.213110657838351,
                lng: 106.82010690652227
            },
            mapZoom: 15,
            mapApiLoaded: false,
            mapInstance: null,
            mapApi: null,
            places: [],

            locID: '',
            locPinPoint: '',
            locDistance: '',
            locDistanceDisplay: '',
            locProvinsi: '',
            locKota: '',
            locKecamatan: '',
            locDesa: '',
            locKodepos: '',
            locDetails: '',
            locLabel: '',
            locPenerima: '',
            locPhone: '',
            locCommand: ''
        }
    }

    componentDidMount() {
        if(!this.state.sessUserCode){
            window.location.href = './login?redirectUrl=' + base64_encode(window.location.href);
        }else{
            this.getLocationDetail();
        }
    }

    getLocationDetail = () => {
        this.setState({
            locID: (this.state.urlParam.trxid) ? base64_decode(this.state.urlParam.trxid) : '',
            locCommand: (this.state.urlParam.action) ? this.state.urlParam.action : ''
        }, () => {
            if(this.state.locID && this.state.locCommand == 'update'){
                Helpers.getListLokasiPengiriman(this.state.locID,'', this.state.branchCode).then(res => {
                    const result = res[0];

                    this.setState({
                        mapCenter: {
                            lat: parseFloat(result.Latitude),
                            lng: parseFloat(result.Longitude)
                        },

                        locPinPoint: result.PinPoint,
                        locDistance: result.Jarak,
                        locProvinsi: result.Provinsi,
                        locKota: result.Kota,
                        locKecamatan: result.Kecamatan,
                        locDesa: result.Desa,
                        locKodepos: result.KodePos,
                        locDetails: result.Detail,
                        locLabel: result.Nama,
                        locPenerima: result.Penerima,
                        locPhone: result.NoPonsel
                    }, () => {
                        this.googleLocationDetails();
                    });
                })
            }else{
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition((position) => {
                        this.setState({
                            mapCenter: {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            }
                        }, () => {
                            this.googleLocationDetails();
                        });
                    });
                }
            }
        });
    };

    googleLocationDetails = () => {
        const latlng = this.state.mapCenter.lat + ',' + this.state.mapCenter.lng;

        Helpers.googleLocationDetails(latlng).then(res => {
            this.defaultPlace(res.results[0]);
        });
    };

    handleGenerateMaps = () => {
        const generateMaps = <GoogleMap
            defaultZoom={this.state.mapZoom}
            defaultCenter={this.state.mapCenter}
            bootstrapURLKeys={{
                key: Connection.MAPS_API_KEY,
                libraries: ['places', 'geometry'],
            }}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={({ map, maps }) => this.apiHasLoaded(map, maps)}>
            <Marker lat={parseFloat(this.state.mapCenter.lat)} lng={parseFloat(this.state.mapCenter.lng)} />
        </GoogleMap>

        this.setState({
            generateMaps
        });
    };

    apiHasLoaded = (map, maps) => {
        this.setState({
            mapApiLoaded: true,
            mapInstance: map,
            mapApi: maps,
        });
    };

    defaultPlace = (place) => {
        this.setState({
            places: [place],
            mapCenter: {
                lat: place.geometry.location.lat,
                lng: place.geometry.location.lng
            },
            locPinPoint: place.formatted_address,
            locProvinsi: place.address_components.find(x => x.types[0] === 'administrative_area_level_1').long_name,
            locKota: place.address_components.find(x => x.types[0] === 'administrative_area_level_2').long_name,
            locKecamatan: place.address_components.find(x => x.types[0] === 'administrative_area_level_3').long_name,
            locDesa: place.address_components.find(x => x.types[0] === 'administrative_area_level_4').long_name
        }, () => {
            this.countDistance();
        });
    };

    addPlace = (place) => {
        this.setState({
            places: [place],
            mapCenter: {
                lat: place.geometry.location.lat(),
                lng: place.geometry.location.lng()
            },
            locPinPoint: place.formatted_address,
            locProvinsi: place.address_components.find(x => x.types[0] === 'administrative_area_level_1').long_name,
            locKota: place.address_components.find(x => x.types[0] === 'administrative_area_level_2').long_name,
            locKecamatan: place.address_components.find(x => x.types[0] === 'administrative_area_level_3').long_name,
            locDesa: place.address_components.find(x => x.types[0] === 'administrative_area_level_4').long_name
        }, () => {
            this.countDistance();
        });
    };

    countDistance = () => {
        const destination = this.state.mapCenter.lat + ',' + this.state.mapCenter.lng
        Helpers.countDistance(destination,this.state.branchCode).then(res => {
            this.setState({
                locDistance: res[0].distanceValue,
                locDistanceDisplay: res[0].distanceText + ' / ' + res[0].durationText,
            }, () => {
                this.handleGenerateMaps();
            });
        })
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.submitData((this.state.locID) ? 'update' : 'insert');
    };

    handleDelete = () => {
        if (window.confirm('Apakah anda yakin akan menghapus lokasi ini?')) {
            this.submitData('delete');
        }
    };

    submitData = (command) => {
        Helpers.saveLokasiPengiriman(
            this.state.sessEmail,
            this.state.locID,
            this.state.sessStore,
            this.state.sessUserType,
            this.state.locLabel,
            this.state.locPenerima,
            this.state.locPhone,
            this.state.locDetails,
            this.state.locPinPoint,
            this.state.locProvinsi,
            this.state.locKota,
            this.state.locKecamatan,
            this.state.locDesa,
            this.state.mapCenter.lat,
            this.state.mapCenter.lng,
            this.state.locDistance,
            '',
            this.state.locKodepos,
            command
        ).then(res => {
            if(res.length > 0){
                if(res[0].alert == 'success'){
                    setTimeout(function() {
                        window.location.href = './location';
                    }, 1000);
                }

                toast[res[0].alert](res[0].message);
            }else{
                toast.error(Helpers.MSG_ERROR);
            }
        })
    };

    render() {
        return (
            <>
                <main className="main pages detail-page-wrap">
                    <div className="detail-topbar">
                        <a href="./location" className="detail-topbar-back"><i className="fi-rs-arrow-small-left"></i></a>
                        <h1 className="detail-topbar-title">{(this.state.locID) ? 'Ubah Lokasi' : 'Tambah Lokasi'}</h1>
                    </div>

                    <div className="detail-wrap">
                        {
                            this.state.mapApiLoaded && (
                                <AutoComplete map={this.state.mapInstance} mapApi={this.state.mapApi} addplace={this.addPlace} />
                            )
                        }
                        <div className="location-map-card">
                            <div style={{ height: '260px', width: '100%' }}>
                                {this.state.generateMaps}
                            </div>
                        </div>

                        <form method="post" onSubmit={(e) => {this.handleSubmit(e)}}>
                            <div className="detail-card">
                                <div className="detail-card-head">
                                    <span className="detail-card-accent"></span>
                                    <span className="detail-card-title">Info Alamat</span>
                                </div>

                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-marker auth-input-icon"></i>
                                    <textarea className="location-textarea" value={this.state.locPinPoint} onChange={e => this.setState({locPinPoint: e.target.value})}
                                              placeholder="Cari atau arahkan pin sesuai lokasi anda"
                                              readOnly required />
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-time-past auth-input-icon"></i>
                                    <input value={this.state.locDistanceDisplay} onChange={e => this.setState({locDistanceDisplay: e.target.value})}
                                           placeholder="Estimasi Jarak & Waktu Tempuh Dari Gudang"
                                           type="text" readOnly required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-globe auth-input-icon"></i>
                                    <input value={this.state.locProvinsi} onChange={e => this.setState({locProvinsi: e.target.value})}
                                           placeholder="Provinsi"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-globe auth-input-icon"></i>
                                    <input value={this.state.locKota} onChange={e => this.setState({locKota: e.target.value})}
                                           placeholder="Kota"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-globe auth-input-icon"></i>
                                    <input value={this.state.locKecamatan} onChange={e => this.setState({locKecamatan: e.target.value})}
                                           placeholder="Kecamatan"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-globe auth-input-icon"></i>
                                    <input value={this.state.locDesa} onChange={e => this.setState({locDesa: e.target.value})}
                                           placeholder="Desa"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group">
                                    <i className="fi-rs-envelope auth-input-icon"></i>
                                    <input value={this.state.locKodepos} onChange={e => this.setState({locKodepos: e.target.value})}
                                           placeholder="Kode Pos"
                                           type="text" maxLength={5}/>
                                </div>
                            </div>

                            <div className="detail-card">
                                <div className="detail-card-head">
                                    <span className="detail-card-accent"></span>
                                    <span className="detail-card-title">Detail Alamat</span>
                                </div>

                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-home auth-input-icon"></i>
                                    <input value={this.state.locDetails} onChange={e => this.setState({locDetails: e.target.value})}
                                           placeholder="Detail Alamat, e.g. Gang Sukasenang No. 14"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-bookmark auth-input-icon"></i>
                                    <input value={this.state.locLabel} onChange={e => this.setState({locLabel: e.target.value})}
                                           placeholder="Simpan Alamat Sebagai, e.g. Rumah"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group mb-15">
                                    <i className="fi-rs-user auth-input-icon"></i>
                                    <input value={this.state.locPenerima} onChange={e => this.setState({locPenerima: e.target.value})}
                                           placeholder="Nama Penerima"
                                           type="text" required/>
                                </div>
                                <div className="auth-input-group">
                                    <i className="fi-rs-smartphone auth-input-icon"></i>
                                    <input value={this.state.locPhone} onChange={e => this.setState({locPhone: e.target.value})}
                                           min={0}
                                           placeholder="Nomor Handphone Penerima"
                                           type="number" required/>
                                </div>
                            </div>

                            <button type="submit" className="auth-btn-primary mb-15">Simpan</button>

                            {
                                this.state.locID && (
                                    <button type="button" className="auth-btn-outline" onClick={this.handleDelete}>Hapus</button>
                                )
                            }
                        </form>
                    </div>
                </main>
            </>
        );
    }
}

export default New;
